import { render } from "./ContactsUser.vue?vue&type=template&id=f3c0d390&scoped=true"
import script from "./ContactsUser.vue?vue&type=script&lang=js"
export * from "./ContactsUser.vue?vue&type=script&lang=js"

import "./ContactsUser.vue?vue&type=style&index=0&id=f3c0d390&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c0d390"]])

export default __exports__